import { Component, Input, OnInit,ChangeDetectorRef, ViewChild, AfterViewInit, ElementRef ,ViewChildren, QueryList } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, NgModel,NgControl } from "@angular/forms";
import { ProfileDetails, ResponseField, Experience, Education } from '../../Models/profile.model';
import { ProfileService } from '../../Services/profile.service';
import { ResumeUploadService } from '../../Services/resume-upload.service';
import { WidgetInput } from '../../../Common/Models/widget.model';
import { SanitizePipe} from '../../../Common/pipes/sanitize.pipe';
import DOMPurify from 'dompurify';
import { FieldErrorDirective } from '../../../Common/Directives/field-error.directive';
import { ValidationUtils } from '../../../Common/Util/validation.utils';
import { NoSpecialCharsDirective } from '../../../Common/Directives/no-html.directive';
import { PhoneValidatorDirective } from "../../../Common/Directives/phone-validator.directive";
import { CustomEmailValidatorDirective } from "../../../Common/Directives/email-validator.directive";
import { A11yModule,FocusMonitor, LiveAnnouncer } from '@angular/cdk/a11y';
import { TranslateModule } from "@ngx-translate/core";
import { TranslationInitService } from '../../../../services/Translate_Services/translation-init.service';
import { TgSettingsService } from "app/services/TG-Setting_Services/tg-settings.service";
import { SessionItemsService } from "../../Services/Session-Items.service";




interface CustomSection {
  Title: string;
  Items: string[];
}

@Component({
  selector: "app-resume-generate",
  standalone: true,
  imports: [CommonModule, FormsModule, SanitizePipe, FieldErrorDirective, NoSpecialCharsDirective, PhoneValidatorDirective, CustomEmailValidatorDirective,A11yModule,TranslateModule],
  templateUrl: "./resume-generate.component.html",
  styleUrls: [
    "./resume-generate.component.scss",
    "./templates/modern-template.scss",
    "./templates/elegant-template.scss",
    "./templates/creative-template.scss",
    "./templates/classic-template.scss",
  ],
})
export class ResumeGenerateComponent implements OnInit, AfterViewInit {
@ViewChild('skillInput', { static: false })
skillInput?: ElementRef<HTMLInputElement>;
@ViewChildren('deleteBtn') deleteButtons!: QueryList<ElementRef>;
    TgSettings: any = {};
  constructor(private focusMonitor: FocusMonitor,
    private liveAnnouncer: LiveAnnouncer,private profileService: ProfileService, private resumeUploadService: ResumeUploadService,private cdr: ChangeDetectorRef,private tgSettingsService: TgSettingsService,private sessionItemsService: SessionItemsService) {
   this.tgSettingsService.settings$.subscribe(settings => {
    this.TgSettings = settings || {};
      this.cdr.markForCheck();
   });}
  @ViewChild('titleInput') titleInput!: NgModel;
  @ViewChild('itemInput') itemInput!: NgModel;
  @ViewChild('titleInput', { read: ElementRef }) titleInputElement!: ElementRef<HTMLInputElement>;
  @ViewChild('itemInput', { read: ElementRef }) itemInputElement!: ElementRef<HTMLInputElement>;
  @ViewChildren(NgControl) formControls!: QueryList<NgControl>;
  profileDetails: ProfileDetails = {
    Responses: [],
    Skills: [],
    Education: [],
    Experience: [],
  };

  translateStrings: any = {};
  customSections: CustomSection[] = [];
  mostRecentEducation: Education | null = null;
  otherEducation: Education[] = [];
  sortedExperience: Experience[] = [];
  showFileNameModal = false;
  fileNameInput: string = "";
  showModal = false;
  showEditForm = false;
  newSectionType = "";
  newSectionTitle = "";
  newSectionItem = "";
  limitError: string = '';
  skillAnnouncement = '';
  newExperience: Experience = {
    PositionTitle: "",
    EmployerName: "",
    Responsibilities: "",
    StartDate: "",
    EndDate: "",
    MostRecent: 0,
  };
  newEducation: Education = {
    Degree: "",
    Major: "",
    SchoolName: "",
    Location: "",
    StartDate: "",
    EndDate: "",
    GradYear: "",
    MostRecent: 0,
  };
  personalDetails: { [key: string]: string } = {
    firstname: "",
    middlename: "",
    lastname: "",
    email: "",
    homephone: "",
    homepage: "",
    address1: "",
    city: "",
    fullstate: "",
    zip: "",
    countryname: "",
  };
  personalDetailsKeys: string[] = [
    "firstname",
    "middlename",
    "lastname",
    "email",
    "homephone",
    "homepage",
    "address1",
    "city",
    "fullstate",
    "zip",
    "countryname",
  ];
  currentNumber: number = 1;
  templates: string[] = ["modern", "elegant", "creative", "classic"];
  currentTemplateIndex: number = 0;
  private requestPayload: any;
  partnerId: string = "";
  siteId: string = "";
  EncryptedSessionId: string = "";
  isPopupVisible = false;
  isLoading = false;
  errorMessage = false;
  pagetype: string = "";
  showConfirmationModal: boolean = false; // New flag for confirmation popup
  unsavedChanges: boolean = false; // Flag to track unsaved changes  
  tempSkills: string[] = [];           // Skills added in this session
  currentSkillInput: string = '';      // Current input box value
  bruid: string | null = null;
  @Input() set widgetData(data: WidgetInput) {
    if (data) {
      this.translateStrings = data.TranslateStrings || {};
      this.partnerId = data.partnerId;
      this.siteId = data.siteId;
      this.EncryptedSessionId = data.sessionId;
      this.fetchProfileData();
      this.profileDetails = data.profileDetails;
      this.pagetype = data.pagetype;
      if (!data.Bruid) {
        this.getsessionItems();
      }
      this.requestPayload = {
        partnerId: +data.partnerId,
        siteId: +data.siteId,
        ReqId: +data.ReqId,
        sessionId: data.sessionId,
        turnOffHttps: false,
        Bruid: data.Bruid || this.bruid
      };
      this.loadData();
      this.loadPersonalDetails();
      this.openModal();
    }
  }

  ngOnInit() {
    this.unsavedChanges = false;
  }
  ngAfterViewInit(): void {
    this.titleInput;
    this.itemInput;
  }
  private getsessionItems(): void { 
    this.sessionItemsService.fetchSessionItems({EncryptedSessionId: this.EncryptedSessionId,SessionItems: ['tg_partner_profileid']}).subscribe({next: (response: any) => {
      const sessionItems = response?.SessionItems;
      if (sessionItems && typeof sessionItems === 'object') {
        const fullValue = sessionItems['tg_partner_profileid'];
        if (fullValue && typeof fullValue === 'string') {
          const parts = fullValue.split('_');
          if (parts.length === 2) {
            const bruid = parts[1].trim();
            this.bruid = bruid;  
          }
        }
      }
    },
    error: (err) => {
      console.error('Failed to fetch tg_partner_profileid', err); 
    }
  });
}
private sanitizeInput(input: string | null | undefined): string {
    if (!input) return '';
    return DOMPurify.sanitize(input, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }).trim();
  }
markAsUnsaved() {
    this.unsavedChanges = true;
  }
 private fetchProfileData(): void {
  const ProfilePayload = {
      partnerId: +this.partnerId,
      siteId: +this.siteId,
      EncryptedSessionId: this.EncryptedSessionId
    };
    if (ProfilePayload) {
      //console.log("Sending request with payload:",ProfilePayload);
      this.profileService.fetchProfileDetails(ProfilePayload).subscribe({
        next: (data: ProfileDetails) => {
          this.profileDetails = {
            Responses: Array.isArray(data.Responses) ? data.Responses : [],
            Skills: Array.isArray(data.Skills) ? data.Skills : [],
            Education: Array.isArray(data.Education) ? data.Education : [],
            Experience: Array.isArray(data.Experience) ? data.Experience : []
          };
          //console.log("Fetched Profile Details:", this.profileDetails);
          this.loadData();
          this.loadPersonalDetails();
          this.openModal();
        },
        error: (error: any) => {
          //console.error("Error fetching profile data:", error);
          this.profileDetails = {
            Responses: [],
            Skills: [],
            Education: [],
            Experience: []
          };
          this.loadData();
          this.loadPersonalDetails();
          this.openModal();
        }
      });
    } else {
      //console.warn("Request payload is not available to fetch profile data.");
      this.profileDetails = {
        Responses: [],
        Skills: [],
        Education: [],
        Experience: []
      };
      this.loadData();
      this.loadPersonalDetails();
      this.openModal();
    }
  }
  getResponseValue(fieldName: string): string {
    const field = this.profileDetails?.Responses?.find(
      (r: ResponseField) => r.Name === fieldName
    );
    return field?.Code || "";
  }

private async saveResumeToServer(htmlBlob: Blob, fileName: string): Promise<void> {

    try {
      // Check file size
      const fileSizeMB = htmlBlob.size / (1024 * 1024);
      //console.log("File size:", fileSizeMB.toFixed(2), "MB");

      // Reject files that are too large (set to 2MB limit)
      const maxFileSizeMB = 2;
      if (fileSizeMB > maxFileSizeMB) {
        alert(
          `File too large (${fileSizeMB.toFixed(
            2
          )}MB). Maximum allowed size is ${maxFileSizeMB}MB. Try simplifying the resume content or selecting a simpler template.`
        );
        return;
      }

      // Create FormData for the upload
      const formData = new FormData();
      formData.append("file", htmlBlob, fileName);
      const clientId = this.requestPayload.partnerId.toString();
      const siteId = this.requestPayload.siteId.toString();
      const encryptedSessionId = this.requestPayload.sessionId;
      const Bruid = this.requestPayload.Bruid || this.bruid || "";
      formData.append("ClientId", clientId);
      formData.append("SiteId", siteId);
      formData.append("EncryptedSessionId", encryptedSessionId);
      formData.append("Source", "resume-builder");
      formData.append("Bruid", Bruid);
      formData.append("AddFileType", "html");
      formData.append("downloadURL", window.location.href);
      formData.append("uploadSource", "resume-builder");
      formData.append("authCode", "");
      formData.append("fileNameWithExtension", fileName);
      formData.append("workFlow", "candidateZone");

      //console.log("Uploading file size:", fileSizeMB.toFixed(2), "MB");

      // Call the service
      this.resumeUploadService.uploadResume(
        clientId,
        siteId,
        encryptedSessionId,
        "resume-builder",
        Bruid,
        "html",
        window.location.href,
        "resume-builder",
        "",
        fileName,
        "candidateZone",
        formData
      ).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.showFileNameModal = false;
          this.fileNameInput = '';
          //console.log("Resume saved successfully to server:", response);
          this.isPopupVisible = true;
                    setTimeout(() => {
            this.isPopupVisible = false;
          }, 4000);          
          const appScope = (window as any).appScope;
          const ChangeNameExtension = fileName.replace('html', 'pdf');
          appScope.resumeAttachedFromAngular(response.Success, ChangeNameExtension,true,false,false);
        },
        error: (error) => {
          //console.error("Full error object:", error);
          if (error.status === 413) {
            console.error(
              "Resume file is too large. Please try with a simpler template or contact support."
            );
          } else {
            this.isLoading = false;
            this.errorMessage = true;
            console.error(
              "Resume generated, but there was an error saving to your profile. Error: " +
                error.status
            );
          }
        },
      });
    } catch (error) {
      console.error("Error preparing resume for server upload:", error);
      //alert("Error preparing resume for upload. Please try again.");
    }
    ValidationUtils.announceAlertSuccess(this.translateStrings.Successfully_Saved_in_My_Files);

}
  openFileNameModal() {
    this.fileNameInput = `${this.getResponseValue('firstname')}_${this.getResponseValue('lastname')}_Resume`;
    this.showFileNameModal = true;
    this.isLoading = false;
    setTimeout(() => {
      ValidationUtils.announceAlertSuccess(`FILE NAME DIALOG OPENED. Press Tab to navigate.`);
      document.getElementById('closeFileNameModalBtn')?.focus();
    }, 0);
  }

  closeFileNameModal() {
    if (!this.isLoading) { // Only allow closing if not loading
      this.showFileNameModal = false;
      this.fileNameInput = '';
      this.isLoading = false;
    }
  }
async saveResumeAsHTML() { 
  this.errorMessage = false; // Clear previous state
if (!this.fileNameInput || this.fileNameInput.trim() === "") {
    this.errorMessage = true;
    return;
  }

  const value = this.fileNameInput;

  // 2. BLOCK dangerous HTML/script patterns
  const forbiddenPattern =  /<\s*script[\s\S]*?>|<\/\s*script\s*>|<\s*img[\s\S]*?>|<[^>]+>|on\w+\s*=|javascript:|<!--|-->/gi;
  if (forbiddenPattern.test(value)) {
    this.errorMessage = true;  // show UI error
    return;
  }
  const safePattern = /^[a-zA-Z0-9_\-\.\s\(\)\{\}\[\]]+$/;
  if (!safePattern.test(value)) {
    this.errorMessage = true;
    return;
  }

  this.isLoading = true;
  const sanitizedFileName = value.trim().replace(/\s+/g, "_") + ".html";

    this.closeFileNameModal();

    const element = document.querySelector('.resume-modal');
    if (element) {
      const contentClone = element.cloneNode(true) as HTMLElement;
      // Remove unwanted elements
      const elementsToRemove = contentClone.querySelectorAll('.modal-footer, .edit-form, .arrow-buttons,.modal-button-container,.popup-content');
      elementsToRemove.forEach(el => el.remove());
      contentClone.classList.remove('modal', 'resume-modal');
      contentClone.classList.add('resume-content', this.getCurrentTemplate());

      // Define CSS for base and each template
        const baseStyles = `.resume-content{max-width:8.5in;margin:0 auto;padding:0.5in;box-sizing:border-box;font-family:Arial,sans-serif;font-size:16px;line-height:1.5;border:2px solid #e0e0e0}.resume-section{margin-bottom:1em}h2,h3{margin:0.5em 0}p{margin:0.3em 0}ul{padding-left:20px}table{width:100%;border-collapse:collapse}td{padding:0;vertical-align:top}`;     
         const templateStyles: { [key: string]: string } = {
        classic: `.resume-content{max-width:8.5in;width:100%;margin:0 auto;padding:0;box-sizing:border-box;font-family:'Times New Roman',Times,serif;font-size:16px;line-height:1.5;overflow-x:hidden;}.resume-section{margin-bottom:1em;}h2,h3{margin:0.5em 0;}p{margin:0.3em 0;}ul{padding-left:20px;}table{width:100%;border-collapse:collapse;}td{padding:0;vertical-align:top;}.classic{font-family:'Times New Roman',Times,serif;max-width:8.5in;width:100%;margin:0 auto;background:#ffffff;border-radius:0;display:block;overflow-x:hidden;}.classic .resume-header{background:#ffffff;color:#000;padding:2px;text-align:center;border-bottom:1px solid #e0e0e0;}.classic .resume-header .name{font-size:2rem;font-weight:700;margin:0 0 10px;text-transform:uppercase;display:block;}.classic .resume-header .contact{font-size:0.9rem;margin:5px 0;display:block;text-align:center;}.classic .resume-header .contact a{color:#000;text-decoration:none;margin:0 10px;display:inline-block;}.classic .resume-header .contact a:hover{color:#7f8c8d;}.resume-scrollable-body{padding:2px;}.classic .resume-body.single-column-layout{padding:5px;}.classic .resume-section{margin-bottom:20px;}.classic .resume-section h2{font-size:1.4rem;font-weight:700;color:#2c3e50;text-transform:uppercase;border-bottom:1px solid #e0e0e0;padding-bottom:5px;margin-bottom:10px;text-align:left;}.classic .objective-section{margin-bottom:20px;}.classic .objective-section p{font-size:0.9rem;color:#000;margin:5px 0;}.classic .experience-section .experience-block{margin-bottom:15px;page-break-inside:avoid;}.classic .experience-section .experience-block h3{font-size:1rem;font-weight:700;color:#2c3e50;margin:0 0 5px;line-height:1.45;word-wrap:break-word;overflow-wrap:break-word;white-space:normal!important;word-break:break-word;hyphens:auto;}.classic .experience-section .experience-block p{font-size:0.9rem;color:#000;margin:5px 0;word-wrap:break-word;overflow-wrap:break-word;white-space:normal!important;word-break:break-word;}.classic .education-section .education-item{margin-bottom:15px;page-break-inside:avoid;}.classic .education-section .education-item h3{font-size:1rem;font-weight:700;color:#2c3e50;margin:0 0 5px;word-wrap:break-word;overflow-wrap:break-word;white-space:normal!important;word-break:break-word;hyphens:auto;}.classic .education-section .education-item p{font-size:0.9rem;color:#000;margin:5px 0;line-height:1.5;word-wrap:break-word;overflow-wrap:break-word;white-space:normal!important;word-break:break-word;}.classic .experience-section .experience-block .responsibilities-text{font-size:10pt;color:#000;line-height:1.5;white-space:pre-wrap;margin:3px 0;font-family:inherit;word-wrap:break-word;overflow-wrap:break-word;word-break:break-word;}.responsibilities-title{font-size:0.9rem;color:#000;margin:5px 0;}.classic .custom-section{margin-bottom:20px;page-break-inside:avoid;}.classic .custom-section h2{word-break:break-all!important;overflow-wrap:anywhere!important;}.classic .custom-section p{font-size:0.9rem;color:#000;margin:5px 0;white-space:normal!important;word-wrap:break-word;overflow-wrap:break-word;line-height:1.6;max-width:100%;margin:8px 0;word-break:break-all!important;overflow-wrap:anywhere!important;hyphens:auto!important;}.@media(max-width:768px){.classic{margin:0;width:100%;}.classic .resume-header{padding:15px;}.classic .resume-header .name{font-size:1.6rem;}.classic .resume-header .contact{display:block;text-align:center;}.classic .resume-body.single-column-layout{padding:10px;}}@media print{body{margin:0!important;padding:0!important;}.classic{box-shadow:none;margin:0!important;padding:0!important;width:8.5in;max-width:8.5in;}.resume-content{margin:0!important;padding:0!important;}.classic .resume-body{overflow:visible;}}`,
        modern: `.modal-backdrop{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:1040;}.resume-modal{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:white;border-radius:8px;z-index:1050;max-width:900px;width:90%;max-height:90vh;display:flex;flex-direction:column;overflow:hidden;}.resume-scrollable{flex:1;overflow-y:auto;padding:15px;}.modal-button-container{position:sticky;bottom:0;display:flex;justify-content:space-between;align-items:center;padding:0 10px 10px 10px;border-top:1px solid #e0e0e0;z-index:1;}.arrow-buttons{display:flex;gap:10px;}.action-buttons{display:flex;gap:10px;}.modern .resume-content{width:100%;max-width:210mm;min-height:297mm;margin:0 auto;padding:10mm;box-sizing:border-box;font-family:'Inter',Arial,sans-serif;font-size:11pt;line-height:1.4;background:#ffffff;}.modern .resume-header{background:#2c3e50;color:#ffffff;padding:10px;text-align:center;border-bottom:2px solid #34495e;}.modern .resume-header .header-table{width:100%;border-collapse:collapse;}.modern .resume-header .header-table td{vertical-align:middle;}.modern .resume-header .name{font-size:20pt;font-weight:700;margin:0;}.modern .resume-header .details{font-size:10pt;margin:5px 0;}.modern .resume-header .details a{color:#ecf0f1;text-decoration:none;margin:0 5px;}.modern .resume-header .details a:hover{text-decoration:underline;}.modern .resume-header .details span{margin:0 5px;}.modern .resume-body{display:flex;gap:15px;padding:10px 0;}.modern .left-column{width:35%;padding-right:10px;}.modern .right-column{width:65%;padding-left:10px;}.modern .resume-section{margin-bottom:15px;}.modern .resume-section h2{font-size:14pt;font-weight:700;color:#2c3e50;border-bottom:2px solid #3498db;padding-bottom:5px;margin-bottom:10px;}.modern .skills-section .skills-list{list-style:none;padding:0;margin:0;}.modern .skills-section .skills-list li{background:#ecf0f1;padding:5px 8px;font-size:10pt;color:#2c3e50;margin-bottom:5px;border-radius:3px;}.modern .education-section .education-item{margin-bottom:10px;}.modern .education-section .education-item h3{font-size:11pt;font-weight:600;color:#2c3e50;margin:0 0 5px;word-wrap:break-word;overflow-wrap:break-word;white-space:normal!important;word-break:break-word;hyphens:auto;}.modern .education-section .education-item .tag{background:#3498db;color:#ffffff;padding:2px 6px;font-size:8pt;border-radius:3px;vertical-align:middle;}.modern .education-section .education-item p{font-size:10pt;color:#555;margin:3px 0;line-height:1.5;word-wrap:break-word;overflow-wrap:break-word;white-space:normal!important;word-break:break-word;}.modern .experience-section .experience-block{margin-bottom:10px;}.modern .experience-section .experience-block h3{font-size:11pt;font-weight:600;color:#2c3e50;margin:0 0 5px;line-height:1.45;word-wrap:break-word;overflow-wrap:break-word;white-space:normal!important;word-break:break-word;hyphens:auto;}.modern .experience-section .experience-block p{font-size:10pt;color:#555;margin:3px 0;word-wrap:break-word;overflow-wrap:break-word;white-space:normal!important;word-break:break-word;}.modern .experience-section .experience-block .responsibilities-text{font-size:10pt;color:#555;line-height:1.5;white-space:pre-wrap;margin:3px 0;font-family:inherit;word-wrap:break-word;overflow-wrap:break-word;word-break:break-word;}.modern .responsibilities-title{font-size:0.9rem;color:#555;margin:5px 0;white-space:pre-wrap;word-wrap:break-word;overflow-wrap:break-word;word-break:break-word;}.modern .custom-section ul{list-style:none;padding:0;margin:0;}.modern .custom-section ul,.modern .custom-section ul *{list-style:none;padding:0!important;margin:0!important;}.modern .custom-section ul li,.modern .custom-section ul li *{background:#ecf0f1;padding:8px 12px!important;margin-bottom:7px!important;border-radius:6px!important;font-size:10.2pt!important;line-height:1.48!important;color:#2c3e50!important;border-left:3px solid #3498db!important;box-shadow:0 1px 3px rgba(0,0,0,0.08)!important;word-break:break-all!important;overflow-wrap:anywhere!important;white-space:normal!important;hyphens:auto!important;overflow:hidden!important;display:block!important;}.modern .custom-section h2{font-size:14pt;font-weight:700;color:#2c3e50;border-bottom:2px solid #3498db;padding-bottom:5px;margin-bottom:10px;word-break:break-all!important;overflow-wrap:anywhere!important;}.modern h2,.modern h3{margin:0;line-height:1.2;}.modern p{margin:0;}.modern ul{padding-left:0;margin:0;}.edit-form{display:block;margin-top:20px;padding:15px;background:#f8f9fa;border-radius:8px;}.edit-form h2{font-size:1.4em;margin-bottom:15px;}.edit-form label{display:block;margin:10px 0 5px;font-weight:500;}.edit-form input,.edit-form textarea,.edit-form select{width:100%;margin-bottom:10px;border:1px solid #ccc;border-radius:4px;box-sizing:border-box;}.edit-form button{padding:8px 16px;border:none;border-radius:4px;cursor:pointer;}.section-type-wrapper{margin-bottom:15px;}.select-with-help{display:flex;align-items:center;}.help-icon{margin-left:10px;font-size:1.2em;color:#007bff;cursor:pointer;}.item-list{list-style:none;padding:0;margin:10px 0;}.item-list li{display:flex;align-items:center;justify-content:space-between;padding:5px 0;}.remove-icon{color:#dc3545;cursor:pointer;font-size:1em;transition:color .2s;}.remove-icon:hover{color:#a71d2a;}.custom-section-form .item-list>li{background:white;border:1px solid #ddd;border-radius:6px;padding:15px;margin-bottom:15px;position:relative;}.custom-section-form .section-text{font-weight:600;color:#2c3e50;margin-right:30px;}.custom-section-form .item-list>li>.remove-icon{position:absolute;top:15px;right:15px;font-size:16px;padding:5px;}.custom-section-form .item-list>li>.remove-icon:hover{background:#dc3545;color:white;}.custom-section-form .item-list>li>ul{list-style:none;padding:0;margin:15px 0 0;}.custom-section-form .item-list>li>ul>li{display:flex;justify-content:space-between;align-items:center;padding:8px 12px;margin-bottom:5px;background:#f8f9fa;border-left:3px solid #3498db;border-radius:4px;}.custom-section-form .item-list>li>ul>li:hover{background:#e9ecef;}.custom-section-form .item-text{flex:1;margin-right:10px;}.custom-section-form .item-list>li>ul>li>.remove-icon{font-size:14px;padding:4px;}.custom-section-form .item-list>li>ul>li>.remove-icon:hover{background:#dc3545;color:white;}.file-name-modal{position:fixed;top:0;left:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;z-index:1050;}.file-name-modal .modal-content{width:400px;max-width:90%;border-radius:12px;box-shadow:0 6px 20px rgba(0,0,0,0.25);}.file-name-modal .modal-header{display:flex;justify-content:space-between;align-items:center;padding:12px 16px;border-bottom:1px solid #ddd;}.file-name-modal .modal-header h2{margin:0;font-size:18px;font-weight:600;}.file-name-modal .modal-body{padding:16px;display:flex;flex-direction:column;gap:10px;}.file-name-modal .modal-body input{padding:8px;border:1px solid #ccc;border-radius:6px;width:100%;}.file-name-modal .modal-footer{display:flex;justify-content:flex-end;gap:10px;padding:12px 16px;border-top:1px solid #ddd;}.btn{padding:8px 16px;border-radius:4px;cursor:pointer;}.btn-primary{border:none;}.btn-secondary{border:none;}.edit-form input:focus,.edit-form textarea:focus,.edit-form select:focus,.help-icon:focus,.btn:focus{outline:2px solid #007bff;outline-offset:2px;}@media print{.resume-modal{position:static;width:100%;height:auto;margin:0;padding:0;box-shadow:none;overflow:visible;}.resume-scrollable{max-height:none;overflow:visible;padding:0;}.modal-button-container,.edit-form,.modal-backdrop{display:none;}.modern .resume-content{width:210mm;min-height:297mm;padding:10mm;margin:0;box-shadow:none;}.modern .resume-body{padding:0;}.modern .resume-header{padding:10px;}}@media(max-width:768px){.resume-modal{width:95%;max-height:95vh;}.modern .resume-body{flex-direction:column;}.modern .left-column,.modern .right-column{width:100%;padding:0;}.modal-button-container{flex-direction:column;gap:10px;}.arrow-buttons,.action-buttons{justify-content:flex-end;width:100%;}}.action-buttons{justify-content:flex-end;width:100%;}`,
        creative: `.creative{font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;max-width:900px;margin:30px auto;background:#ffffff;border-radius:12px;box-shadow:0 6px 18px rgba(0,0,0,0.08);display:flex;flex-direction:column;height:100%;}.creative .resume-scrollable-body{flex:1;padding:30px;}.creative .resume-scrollable-body::-webkit-scrollbar{width:6px;}.creative .resume-scrollable-body::-webkit-scrollbar-track{background:#f8fafc;}.creative .resume-scrollable-body::-webkit-scrollbar-thumb{background:#64748b;border-radius:3px;}.creative .resume-scrollable-body .edit-form{display:block;margin-top:20px;padding:20px;background:#ffffff;border:1px solid #e2e8f0;border-radius:8px;box-shadow:0 4px 12px rgba(0,0,0,0.05);}.creative .resume-scrollable-body .edit-form h2{font-size:1.4rem;color:#2c3e50;margin-bottom:15px;}.creative .resume-scrollable-body .edit-form label{display:block;font-size:0.95rem;color:#555;margin-bottom:5px;}.creative .resume-scrollable-body .edit-form input,.creative .resume-scrollable-body .edit-form select,.creative .resume-scrollable-body .edit-form textarea{width:100%;padding:8px;margin-bottom:10px;border:1px solid #e2e8f0;border-radius:4px;font-size:0.95rem;}.creative .resume-scrollable-body .edit-form button{border:none;padding:10px 20px;border-radius:6px;font-size:0.9rem;}.creative .resume-header{background:#3498db;color:#ffffff;padding:30px;text-align:center;}.creative .resume-header .name{font-size:2.25rem;font-weight:700;margin:0 0 15px;letter-spacing:0.5px;}.creative .resume-header .contact{font-size:1rem;display:flex;justify-content:center;flex-wrap:wrap;gap:15px;margin:8px 0;}.creative .resume-header .contact a{color:#ffffff;text-decoration:none;}.creative .resume-header .contact span{display:flex;align-items:center;gap:8px;}.creative .resume-header .contact i{color:#ffffff;font-size:1rem;}.creative .resume-body.sidebar-layout{display:flex;gap:30px;padding:0 20px;}.creative .sidebar{flex:1;background:#ecf0f1;padding:20px;border-right:2px solid #3498db;}.creative .main-content{flex:2;padding:20px;}.creative .resume-section{margin-bottom:30px;}.creative .resume-section h2{font-size:1.6rem;font-weight:600;color:#2c3e50;border-bottom:2px solid #3498db;padding-bottom:8px;margin-bottom:15px;}.creative .skills-section .skills-list{list-style:disc;padding-left:20px;}.creative .skills-section .skills-list li{font-size:0.95rem;color:#2c3e50;margin-bottom:8px;}.creative .custom-section{margin-bottom:30px;}.creative .custom-section ul{list-style:disc;padding-left:20px;}.creative .custom-section ul li{font-size:0.95rem;color:#2c3e50;margin-bottom:10px;}.creative .education-section .education-item{margin-bottom:20px;padding:15px;border-radius:8px;}.creative .education-section .education-item h3{font-size:1.15rem;font-weight:600;color:#2c3e50;margin:0 0 8px;word-wrap:break-word;overflow-wrap:break-word;white-space:normal!important;word-break:break-word;hyphens:auto;}.creative .education-section .education-item p{font-size:0.95rem;color:#555;margin:5px 0;line-height:1.5;word-wrap:break-word;overflow-wrap:break-word;white-space:normal!important;word-break:break-word;}.creative .experience-section .experience-block{margin-bottom:20px;padding:15px;border-radius:8px;}.creative .experience-section .experience-block h3{font-size:1.15rem;font-weight:600;color:#2c3e50;margin:0 0 8px;line-height:1.45;word-wrap:break-word;overflow-wrap:break-word;white-space:normal!important;word-break:break-word;hyphens:auto;}.creative .experience-section .experience-block p{font-size:0.95rem;color:#555;margin:5px 0;word-wrap:break-word;overflow-wrap:break-word;white-space:normal!important;word-break:break-word;}.creative .experience-section .experience-block .responsibilities-text{font-size:10pt;color:#555;line-height:1.5;white-space:pre-wrap;margin:3px 0;font-family:inherit;word-wrap:break-word;overflow-wrap:break-word;word-break:break-word;hyphens:auto;overflow:visible!important;display:block!important;font-style:normal!important;}.creative .experience-section .experience-block .responsibilities-title{font-size:0.9rem;color:#555;margin:5px 0;}@media(max-width:768px){.creative{margin:15px;height:auto;}.creative .resume-header{padding:20px;}.creative .resume-header .name{font-size:1.8rem;}.creative .resume-header .contact{flex-direction:column;gap:8px;}.creative .resume-scrollable-body{padding:20px;}.creative .resume-body.sidebar-layout{flex-direction:column;}.creative .sidebar,.creative .main-content{width:100%;border-right:none;padding:0;}}@media print{.creative{box-shadow:none;margin:0;max-width:100%;height:auto;}.creative .resume-scrollable-body{overflow:visible;}.creative .modal-footer{display:none;}}.creative .custom-section h2{word-break:break-all!important;overflow-wrap:anywhere!important;}.creative .custom-section ul li{white-space:normal!important;word-wrap:break-word;overflow-wrap:break-word;line-height:1.5;max-width:100%;padding-right:10px;display:block;text-overflow:ellipsis;overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;word-break:break-all!important;overflow-wrap:anywhere!important;word-wrap:break-word!important;white-space:normal!important;hyphens:auto!important;}}`,
        elegant: `.elegant{font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;max-width:900px;margin:40px auto;background:#ffffff;border-radius:16px;box-shadow:0 8px 24px rgba(0,0,0,0.08);display:flex;flex-direction:column;min-height:100vh;}.elegant .resume-scrollable-body{flex:1;padding:40px;overflow-y:auto;}.elegant .resume-scrollable-body::-webkit-scrollbar{width:8px;}.elegant .resume-scrollable-body::-webkit-scrollbar-track{background:#f9fafb;border-radius:4px;}.elegant .resume-scrollable-body::-webkit-scrollbar-thumb{background:#6b7280;border-radius:4px;transition:background .3s ease;}.elegant .resume-scrollable-body::-webkit-scrollbar-thumb:hover{background:#4b5563;}.elegant .edit-form{display:block;margin-top:25px;padding:25px;background:#ffffff;border:1px solid #e5e7eb;border-radius:10px;box-shadow:0 4px 16px rgba(0,0,0,0.06);}.elegant .edit-form h2{font-size:1.5rem;font-weight:600;color:#1e3a8a;margin-bottom:20px;}.elegant .edit-form label{display:block;font-size:.95rem;font-weight:500;color:#334155;margin-bottom:8px;}.elegant .edit-form input,.elegant .edit-form select,.elegant .edit-form textarea{width:100%;margin-bottom:12px;border:1px solid #d1d5db;border-radius:6px;font-size:.95rem;transition:border-color .3s ease,box-shadow .3s ease;}.elegant .edit-form input:focus,.elegant .edit-form select:focus,.elegant .edit-form textarea:focus{outline:none;border-color:#3b82f6;box-shadow:0 0 0 3px rgba(59,130,246,0.1);}.elegant .edit-form button{display:block;border:none;padding:12px 24px;border-radius:8px;font-size:.95rem;font-weight:500;transition:background .3s ease,transform .2s ease;}.elegant .resume-header{background:linear-gradient(90deg,#1e3a8a,#3b82f6);color:#ffffff;padding:50px 40px;text-align:center;border-radius:16px 16px 0 0;position:relative;overflow:hidden;}.elegant .resume-header:before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background:radial-gradient(circle,rgba(255,255,255,0.2),transparent 70%);pointer-events:none;}.elegant .resume-header .name{font-size:2.5rem;font-weight:700;margin:0 0 12px;letter-spacing:.5px;text-transform:capitalize;line-height:1.2;}.elegant .resume-header .contact{display:flex;flex-wrap:wrap;justify-content:center;gap:20px;margin:15px 0;}.elegant .resume-header .contact a{color:#f1f5f9;text-decoration:none;transition:.3s;}.elegant .resume-header .contact a:hover{color:#93c5fd;transform:translateY(-1px);}.elegant .resume-header .contact span{display:flex;align-items:center;gap:10px;}.elegant .resume-header .location{font-size:.95rem;opacity:.9;display:flex;justify-content:center;align-items:center;gap:10px;margin-top:10px;}.elegant .resume-body.single-column-layout{padding:0 30px;}.elegant .resume-section{margin-bottom:40px;}.elegant .resume-section h2{font-size:1.5rem;font-weight:600;color:#1e3a8a;margin-bottom:20px;padding-left:24px;position:relative;transition:color .3s;}.elegant .resume-section h2:before{content:'';position:absolute;left:0;top:3px;height:24px;width:5px;background:#3b82f6;border-radius:3px;}.elegant .resume-section h2:hover{color:#3b82f6;}.elegant .skills-section ul{list-style:none;padding:0;display:flex;flex-wrap:wrap;gap:12px;}.elegant .skills-section ul li{background:#eff6ff;padding:10px 16px;border-radius:999px;font-size:.9rem;font-weight:500;color:#1e3a8a;transition:.3s;}.elegant .skills-section ul li:hover{background:#93c5fd;transform:translateY(-2px);}.elegant .education-section .education-item{margin-bottom:30px;padding:20px;border-radius:10px;transition:background .3s,box-shadow .3s;}.elegant .education-section .education-item:hover{background:#f9fafb;box-shadow:0 4px 12px rgba(0,0,0,0.05);}.elegant .education-section h3,.elegant .experience-section h3{font-size:1.15rem;font-weight:600;color:#1e3a8a;margin:0 0 10px;line-height:1.45;word-break:break-word;hyphens:auto;}.elegant .education-section p,.elegant .experience-section p{font-size:.95rem;color:#334155;margin:6px 0;line-height:1.5;word-break:break-word;}.elegant .experience-section .experience-block{margin-bottom:30px;padding:20px;border-radius:10px;transition:background .3s ease,box-shadow .3s ease;}.elegant .experience-section .experience-block:hover{background:#f9fafb;box-shadow:0 4px 12px rgba(0,0,0,0.05);}.elegant .experience-section .responsibilities-text{font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif !important;font-size:10pt;color:#334155;line-height:1.5;white-space:pre-wrap;margin:3px 0;word-break:break-word;}.elegant .custom-section h2{word-break:break-all!important;overflow-wrap:anywhere!important;}.elegant .custom-section ul li{white-space:normal!important;word-break:break-word;overflow-wrap:break-word;}.elegant .custom-section{margin-bottom:35px;}.elegant .custom-section ul{list-style:none;padding:0;display:flex;flex-wrap:wrap;gap:12px;}.elegant .custom-section ul li{background:#eff6ff;padding:10px 16px;border-radius:20px;font-size:.9rem;color:#1e3a8a;white-space:nowrap;transition:.3s;}.elegant .custom-section ul li:hover{background:#dbeafe;}@media(max-width:768px){.elegant{margin:15px;height:auto;}.elegant .resume-header{padding:20px;}.elegant .resume-header .name{font-size:1.8rem;}.elegant .resume-header .contact{flex-direction:column;gap:8px;}.elegant .resume-body.single-column-layout{padding:0;}}@media print{.elegant{box-shadow:none;margin:0;max-width:100%;height:auto;}.elegant .resume-scrollable-body{overflow:visible;}.elegant .modal-footer{display:none;}}` 
          };

      // Combine base styles with the selected template's styles
      const css = `${baseStyles}${templateStyles[this.getCurrentTemplate()] || templateStyles['modern']}`;

      // Create the HTML content with embedded styles
      const htmlContent = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>${this.getResponseValue('firstname')}_${this.getResponseValue('lastname')}_Resume</title>
          <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&#x26;display=swap" rel="stylesheet">
          <style>
            ${css}
            body { margin: 0 !important; padding: 0 !important; }
            .resume-content { box-sizing: border-box; margin: 0 !important; padding: 0 !important; }
          </style>
        </head>
        <body>
          <div class="resume-content ${this.getCurrentTemplate()}">${contentClone.innerHTML}</div>
        </body>
        </html>
      `;

      try {
        // Create a Blob for the HTML content
        const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
        const fileName = sanitizedFileName;
        await this.saveResumeToServer(htmlBlob, fileName);
        //this.downloadResumeAsHTML(htmlBlob, fileName);
      } catch (error) {
        console.error('Error generating HTML:', error);
        //alert('Error generating HTML. Please try again.');
      }

    }
}

downloadResumeAsHTML(htmlBlob: Blob, fileName: string) {
    try {
      // Create a URL for the Blob
      const url = window.URL.createObjectURL(htmlBlob);
      
      // Create a temporary anchor element to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      //console.log('Resume downloaded successfully:', fileName);
    } catch (error) {
      console.error('Error downloading resume:', error);
      //alert('Error downloading resume. Please try again.');
    }
}
  openModal() {
    this.showModal = true;
    this.loadData();
    this.loadPersonalDetails();
    setTimeout(() => {
     const editBtn = document.getElementById('Resume-builder');
    ValidationUtils.announceAlertSuccess(`RESUME BUILDER MODAL OPENED. Press Tab to navigate.`);
     if (editBtn) {
       editBtn.focus();
     }
    }, 0);
  }

  closeModal() {
    if (this.unsavedChanges) {
    this.showConfirmationModal = true; 
    setTimeout(() => {
      document.getElementById('closeConfirmationModalBtn')?.focus();
      });
    }
   else {
    this.showModal = false; 
    this.showEditForm = false;
    this.showFileNameModal = false;
    this.newSectionType = "";
  } 
  }
  cancelConfirmation() {
  this.showConfirmationModal = false;
   setTimeout(() => {
      document.getElementById('confirmBtn')?.focus();
    });
}
confirmClose() {
  this.showConfirmationModal = false;
  this.showModal = false;
}

  toggleEditForm() {
    this.showEditForm = !this.showEditForm;
    if (!this.showEditForm) {
      this.newSectionType = "";
    }
     setTimeout(() => {
      const section = document.getElementById("editFormSection");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
      section.focus();
    }
    const select = document.getElementById("sectionType");
    if (select) {
      select.focus();
    }
    }, 0);
  }

  loadPersonalDetails() {
    this.personalDetails = {
      firstname: this.getResponseValue("firstname"),
      middlename: this.getResponseValue("middlename"),
      lastname: this.getResponseValue("lastname"),
      email: this.getResponseValue("email"),
      homephone: this.getResponseValue("homephone"),
      homepage: this.getResponseValue("homepage"),
      address1: this.getResponseValue("address1"),
      city: this.getResponseValue("city"),
      fullstate: this.getResponseValue("fullstate"),
      zip: this.getResponseValue("zip"),
      countryname: this.getResponseValue("countryname"),
    };
  }
markAllFieldsAsTouched(): void {
const requiredFieldNames = ['firstname', 'lastname', 'email', 'homephone','employerName', 'positionTitle', 'startDate', 'schoolName', 'degree', 'major','title','item'];
  requiredFieldNames.forEach(fieldName => {
      const input = document.querySelector(`input[name="${fieldName}"]`) as HTMLInputElement;
      if (input) {
        input.dispatchEvent(new Event('blur'));
      }
    });
  }

savePersonalDetails() {
this.markAllFieldsAsTouched();
 const firstInvalid = document.querySelector('.personal-details-form input.ng-invalid');
  if (firstInvalid) {
    (firstInvalid as HTMLElement).focus();
    firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return; 
  }
  const firstName = this.personalDetails['firstname']?.trim();
  const lastName = this.personalDetails['lastname']?.trim();
  const email = this.personalDetails['email']?.trim();
  const homephone = this.personalDetails['homephone']?.trim();
  if (!ValidationUtils.hasValue(firstName) ||
      !ValidationUtils.hasValue(lastName) ||  
      !ValidationUtils.hasValue(email) ||
      !ValidationUtils.isValidPhone(homephone) ||
      !ValidationUtils.isValidEmail(email)) {
    return; 
  }
    const updatedResponses = Array.isArray(this.profileDetails.Responses)
      ? [...this.profileDetails.Responses]
      : [];
    this.personalDetailsKeys.forEach((key) => {
      const existingIndex = updatedResponses.findIndex((r) => r.Name === key);
      const value = this.sanitizeInput(this.personalDetails[key]);
      if (value) {
        if (existingIndex !== -1) {
          updatedResponses[existingIndex] = { Name: key, Code: value };
        } else {
          updatedResponses.push({ Name: key, Code: value });
        }
      } else if (existingIndex !== -1) {
        updatedResponses.splice(existingIndex, 1);
      }
    });
    this.profileDetails.Responses = updatedResponses;
    this.saveProfileDetails();
    this.newSectionType = '';
  }

removePersonalDetail(key: string) {

  this.profileDetails.Responses = this.profileDetails.Responses.filter(
    (r) => r.Name !== key
  );
  delete this.personalDetails[key];
  this.personalDetailsKeys = this.personalDetailsKeys.filter(k => k !== key);
  this.saveProfileDetails();
  this.loadData();
}

  getTotalItemsCount() {
  return this.customSections.reduce((total, sec) => total + sec.Items.length, 0);
}

addNewSection() {
if (this.getTotalItemsCount() >= 5) {
    this.limitError = "You can add only 5 custom sections.";
    return;
  } else {
    this.limitError = '';
  }
  this.markAllFieldsAsTouched();
   const firstInvalid = document.querySelector('.custom-section-form input.ng-invalid');
  if (firstInvalid) {
    (firstInvalid as HTMLElement).focus();
    firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return; 
  }
    const title = this.sanitizeInput(this.newSectionTitle).trim();
    const item = this.sanitizeInput(this.newSectionItem).trim();
    if (!ValidationUtils.hasValue(title) || !ValidationUtils.hasValue(item)) {
    return;
  }
    const existing = this.customSections.find(s => s.Title === title);
    if (existing) {
      existing.Items.push(item);
    } else {
      this.customSections.push({ Title: title, Items: [item] });
  }
    this.saveCustomSections();
    this.newSectionTitle = '';
    this.newSectionItem = '';
    this.newSectionType = '';
    // Reset touched
    setTimeout(() => {
      this.titleInput?.control?.markAsUntouched();
      this.itemInput?.control?.markAsUntouched();
      this.cdr.detectChanges();
    });
  }

  removeCustomSection(title: string) {
    this.customSections = this.customSections.filter((s) => s.Title !== title);
    this.saveCustomSections();
  }

  removeCustomItem(title: string, item: string) {
    const section = this.customSections.find((s) => s.Title === title);
    if (section) {
      section.Items = section.Items.filter((i) => i !== item);
      if (section.Items.length === 0) {
        this.customSections = this.customSections.filter(
          (s) => s.Title !== title
        );
      }
      this.saveCustomSections();
       setTimeout(() => {
        if (this.getTotalItemsCount() <= 4) {
      this.limitError = '';
    }});
  }
  }
 addSingleSkill() {
    const skill = this.sanitizeInput(this.currentSkillInput?.trim());

    if (!skill || this.tempSkills.includes(skill)) {
      this.currentSkillInput = '';
      this.restoreFocus();
      return;
    }

    this.tempSkills.push(skill);

    // ✅ Screen-reader announcement (JAWS / NVDA / VO safe)
    this.liveAnnouncer.announce(`${skill} skill added`, 'polite');

    this.currentSkillInput = '';
    this.restoreFocus();
  }

private restoreFocus() {
  if (!this.skillInput?.nativeElement) {
    return;
  }

  this.focusMonitor.focusVia(
    this.skillInput.nativeElement,
    'keyboard'
  );
}


removeTempSkill(index: number): void {
  const removedSkill = this.tempSkills[index];
  this.tempSkills.splice(index, 1);
  this.skillAnnouncement = `${removedSkill} skill removed`;
  setTimeout(() => {
    this.skillAnnouncement = '';

    const removeIcons = document.querySelectorAll(
      '.skills-chips-container .remove-icon-btn'
    ) as NodeListOf<HTMLElement>;

    if (removeIcons.length > 0) {
      const nextIndex =
        index < removeIcons.length ? index : removeIcons.length - 1;

      removeIcons[nextIndex].focus();
    } else {
      const input = document.getElementById('skillItem') as HTMLInputElement;
      input?.focus();
    }
  }, 100);
}


saveAllSkills() {
  if (this.tempSkills.length === 0) return;

  // Make sure Skills array exists
  if (!Array.isArray(this.profileDetails.Skills)) {
    this.profileDetails.Skills = [];
  }

  // Add all temp skills (no duplicates)
  this.tempSkills.forEach(skill => {
    if (!this.profileDetails.Skills.includes(skill)) {
      this.profileDetails.Skills.push(skill);
    }
  });

  // Save once and close
  this.saveProfileDetails();

  // Reset everything
  this.tempSkills = [];
  this.currentSkillInput = '';
  this.newSectionType = ''; // This closes the section
}

removeSkill(skill: string, index: number) {
  this.profileDetails.Skills =
  this.profileDetails.Skills.filter((s) => s !== skill);
  this.saveProfileDetails();
  setTimeout(() => {
    const buttons = this.deleteButtons.toArray();
    if (buttons.length > 0) {
      const newIndex = index >= buttons.length? buttons.length - 1: index;
      buttons[newIndex].nativeElement.focus();
    } 
  });
}

 private showFieldError(fieldName: string, message: string): void {
  const control = this.formControls?.find(c => c.name === fieldName)?.control;
  if (control) {
    control.setErrors({ custom: message });
    control.markAsTouched();
  }
}
addExperience() {
  this.markAllFieldsAsTouched();
   const firstInvalid = document.querySelector('.experience-details-form input.ng-invalid');
  if (firstInvalid) {
    (firstInvalid as HTMLElement).focus();
    firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return; 
  }
  const positionTitle = this.newExperience.PositionTitle?.trim();
  const employerName = this.newExperience.EmployerName?.trim();
  const startDate = this.newExperience.StartDate?.trim();
  if (!ValidationUtils.hasValue(positionTitle) || !ValidationUtils.hasValue(employerName) || !ValidationUtils.hasValue(startDate)) {
    return;
  }
  const sanitizedExperience: Experience = {
    PositionTitle: this.sanitizeInput(this.newExperience.PositionTitle),
    EmployerName: this.sanitizeInput(this.newExperience.EmployerName),
    Responsibilities: this.sanitizeInput(this.newExperience.Responsibilities),
    StartDate: this.sanitizeInput(this.newExperience.StartDate),
    EndDate: this.sanitizeInput(this.newExperience.EndDate),
    MostRecent: this.newExperience.MostRecent,
    };
  if (sanitizedExperience.PositionTitle && sanitizedExperience.EmployerName) {
      if (!Array.isArray(this.profileDetails.Experience)) {
        this.profileDetails.Experience = [];
      }
      this.profileDetails.Experience.push(sanitizedExperience);
      this.loadData();
      this.saveProfileDetails();
      this.newExperience = {
        PositionTitle: '',
        EmployerName: '',
        Responsibilities: '',
        StartDate: '',
        EndDate: '',
        MostRecent: 0,
      };
      this.newSectionType = '';
    }
  }

  removeExperience(experience: Experience) {
    this.profileDetails.Experience = this.profileDetails.Experience.filter(
      (e) => e !== experience
    );
    this.loadData();
    this.saveProfileDetails();
  }
  addEducation() {
  this.markAllFieldsAsTouched();  
 const firstInvalid = document.querySelector('.education-details-form input.ng-invalid');
  if (firstInvalid) {
    (firstInvalid as HTMLElement).focus();
    firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return; 
  }
  const schoolName = this.newEducation.SchoolName?.trim();
  const degree = this.newEducation.Degree?.trim();
  const major = this.newEducation.Major?.trim();
  if (!ValidationUtils.hasValue(schoolName) ||
      !ValidationUtils.hasValue(degree) ||
      !ValidationUtils.hasValue(major)) {
    return; 
  }
    const sanitizedEducation: Education = {
      Degree: this.sanitizeInput(this.newEducation.Degree),
      Major: this.sanitizeInput(this.newEducation.Major),
      SchoolName: this.sanitizeInput(this.newEducation.SchoolName),
      Location: this.sanitizeInput(this.newEducation.Location),
      StartDate: this.sanitizeInput(this.newEducation.StartDate),
      EndDate: this.sanitizeInput(this.newEducation.EndDate),
      GradYear: this.sanitizeInput(this.newEducation.GradYear),
      MostRecent: this.newEducation.MostRecent,
    };
    if (sanitizedEducation.Degree && sanitizedEducation.SchoolName) {
      if (!Array.isArray(this.profileDetails.Education)) {
        this.profileDetails.Education = [];
      }
      this.profileDetails.Education.push(sanitizedEducation);
      this.loadData();
      this.saveProfileDetails();
      this.newEducation = {
        Degree: '',
        Major: '',
        SchoolName: '',
        Location: '',
        StartDate: '',
        EndDate: '',
        GradYear: '',
        MostRecent: 0,
      };
      this.newSectionType = '';
    }
  }

  removeEducation(education: Education) {
    this.profileDetails.Education = this.profileDetails.Education.filter(
      (e) => e !== education
    );
    this.loadData();
    this.saveProfileDetails();
  }

  onMostRecentChange(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target) {
      this.newEducation.MostRecent = target.checked ? 1 : 0;
    }
  }
  private loadData(): void {
    const educationRaw = Array.isArray(this.profileDetails?.Education)? this.profileDetails.Education: [];  
    const education: Education[] = educationRaw.map((edu: any) => ({
    Degree: edu.EduDegree || edu.Degree || '',
    Major: edu.EduMajor || edu.Major || '',
    SchoolName: edu.SchoolName || '',
    Location: edu.Location || '',
    StartDate: edu.StartDate || '',
    EndDate: edu.EndDate || '',
    GradYear: edu.GradYear || '',
  }));

  this.otherEducation = education.filter((edu) => edu.MostRecent !== 1);const experiences = Array.isArray(this.profileDetails.Experience)? this.profileDetails.Experience: [];
  const mostRecent = experiences.filter((exp) => exp.MostRecent === 1);
  const others = experiences.filter((exp) => exp.MostRecent !== 1);
  this.sortedExperience = [...others, ...mostRecent];
}


  saveProfileDetails() {
     this.markAsUnsaved();
    sessionStorage.setItem(
      "profileDetails",
      JSON.stringify(this.profileDetails)
    );
  }

  saveCustomSections() {
      this.markAsUnsaved();
    sessionStorage.setItem(
      "customSections",
      JSON.stringify(this.customSections)
    );
  }

  loadCustomSections() {
      this.markAsUnsaved();
    const savedSections = sessionStorage.getItem("customSections");
    if (savedSections) {
      this.customSections = JSON.parse(savedSections);
    }
  }
allowOnlyDateFormat(event: KeyboardEvent) {
  const separator = this.getSeparator();
    let allowedPattern: RegExp;

  if (separator === '') {
    allowedPattern = /^[0-9a-zA-Z]$/;
  } else if (separator === ' ') {
    // Allow space also
    allowedPattern = /^[0-9a-zA-Z ]$/;
  } else {
    allowedPattern = new RegExp(`^[0-9a-zA-Z\\${separator}]$`);
  }

  if (!allowedPattern.test(event.key)) {
    event.preventDefault();
  }
}

  changeTemplate(direction: "prev" | "next") {
    if (direction === "next") {
      this.currentTemplateIndex =
        (this.currentTemplateIndex + 1) % this.templates.length;
    } else if (direction === "prev") {
      this.currentTemplateIndex =
        (this.currentTemplateIndex - 1 + this.templates.length) %
        this.templates.length;
    }
    const current = this.currentTemplateIndex + 1;
    const total = this.templates.length;
    ValidationUtils.announceAlertSuccess(`Template ${current} of ${total} selected`);
  }

  getCurrentTemplate(): string {
    return this.templates[this.currentTemplateIndex];
  }
  getSeparator(): string {
  let separator = '/';

  const dateFormat = this.TgSettings?.DateFormat;

  if (['3', '6', '9'].includes(dateFormat)) {
    separator = '/';
  } else if (['1', '4', '7', '10'].includes(dateFormat)) {
    separator = '-';
  } else if (['5', '8', '11'].includes(dateFormat)) {
    separator = '.';
  } else if (dateFormat === '2') {
    separator = ' ';
  } else if (dateFormat === '12') {
    separator = '';
  }

  return separator;
}

getPlaceholderMonthFormat(): string {
  const separator = this.getSeparator();
  const format = this.TgSettings?.DateFormat;

  if (format === '1' || format === '2') {
    return `${this.translateStrings.MMM}${separator}${this.translateStrings.YYYY}`;
  }
  if (['3', '4', '5', '6', '7', '8'].includes(format)) {
    return `${this.translateStrings.M}${separator}${this.translateStrings.YYYY}`;
  }
  if (['9', '10', '11', '12'].includes(format)) {
    return `${this.translateStrings.YYYY}${separator}${this.translateStrings.M}`;
  }
  return `${this.translateStrings.M}${separator}${this.translateStrings.YYYY}`;
}
}
